<template>
  <e-sidebar
    id="pay_installment_modal"
    :show="showSidebar"
    :fetching="loading"
    :title="title"
    centered
    size="xl"
    width="90%"
    no-close-on-backdrop
    hide-header-close
    hide-footer
    @hidden="cleanModalData"
  >
    <template #content>
      <b-card-actions
        :title="$t('Dados do pagamento')"
        :show-loading="saving"
        no-actions
      >
        <FormulateForm
          ref="modalPayForm"
          name="modalPayForm"
        >
          <b-row v-if="!isBulkPay && !isPaymentConfirmation">
            <b-col md="2">
              <FormulateInput
                id="modal_pay_installment-value"
                v-model="installmentPayForm.value"
                type="label"
                filter="currency"
                :label="$t('Valor da parcela')"
              />
            </b-col>
            <b-col md="3">
              <FormulateInput
                id="modal_pay_installment-discount"
                v-model="installmentPayForm.discount"
                type="text-number"
                currency="R$"
                :precision="2"
                :label="$t('Desconto')"
                @blur="(value) => onInputDiscount(value, installmentPayForm)"
              />
            </b-col>
            <b-col md="3">
              <FormulateInput
                id="modal_pay_installment-interest"
                v-model="installmentPayForm.interest"
                type="text-number"
                currency="R$"
                :precision="2"
                :label="$t('Juros')"
                @blur="(value) => onInputInterest(value, installmentPayForm)"
              />
            </b-col>
            <b-col md="2">
              <FormulateInput
                id="modal_pay_installment-payment_value"
                v-model="installmentPayForm.paymentValue"
                type="label"
                filter="currency"
                :label="$t('Valor a pagar')"
              />
            </b-col>
            <b-col md="2">
              <FormulateInput
                id="modal_pay_installment-due_date"
                v-model="installmentPayForm.dueDate"
                type="label"
                filter="date"
                :label="$t('Vencimento')"
              />
            </b-col>
          </b-row>

          <b-row v-if="!isPaymentConfirmation">
            <b-col>
              <e-checking-account-combo
                id="modal_pay_installment-input_checking_account"
                ref="checkingAccountCombo"
                v-model="installmentPayForm.checkingAccountId"
                :type="['External']"
                :store-id="storeId"
                :show-only-headquarters-accounts="hasManyStores"
                required
                active-options
                @single-option="(checkAccId) => (installmentPayForm.checkingAccountId = checkAccId)"
                @input="handleCheckingAccountChange"
              />
            </b-col>

            <b-col md="4">
              <FormulateInput
                id="modal_pay_installment-input_payment_date"
                ref="inputPaymentDate"
                v-model="installmentPayForm.paymentDate"
                type="datepicker"
                :hour-default="12"
                :label="$t('Data pagamento')"
                :placeholder="$t('dd/mm/aaaa')"
                class="required"
                validation="required"
              />
            </b-col>
          </b-row>

          <b-row
            v-if="
              isBulkPay &&
                !isPaymentConfirmation &&
                selectedCheckingAccount &&
                selectedCheckingAccount.workspaceId &&
                !hasOtherPaymentMethodsThanPix
            "
          >
            <b-col>
              <FormulateInput
                v-model="installmentPayForm.payOnInternetBanking"
                type="switch"
                :options="{ yes: 'Sim', no: 'Não' }"
                :label="$t('Deseja realizar os pagamentos no Internet Banking?')"
                :element-class="['d-flex', 'mt-1']"
                :instruction="
                  $t(
                    'Quando selecionado, o sistema irá realizar a integração dos pagamentos no Internet Banking.'
                  )
                "
              />
            </b-col>
          </b-row>

          <b-row
            v-if="
              !isBulkPay &&
                !isPaymentConfirmation &&
                selectedCheckingAccount &&
                selectedCheckingAccount.workspaceId
            "
          >
            <b-col>
              <FormulateInput
                v-model="installmentPayForm.payOnInternetBanking"
                type="switch"
                :label="$t('Deseja realizar o pagamento no Internet Banking?')"
                :instruction="
                  $t(
                    'Quando selecionado, o sistema irá realizar a integração do pagamento no Internet Banking.'
                  )
                "
              />
            </b-col>
          </b-row>

          <b-row
            v-if="
              !isBulkPay &&
                !isPaymentConfirmation &&
                selectedCheckingAccount &&
                selectedCheckingAccount.workspaceId &&
                installmentPayForm.payOnInternetBanking &&
                installmentPayForm.paymentMethod.method === paymentTypeEnum.BANK_SLIP
            "
          >
            <b-col md="12">
              <FormulateInput
                v-model="installmentPayForm.internetBankingPaymentType"
                type="radio"
                :options="internetBankingPaymentTypes()"
                :label="$t('Tipo de Boleto')"
                :element-class="['d-flex', 'mt-1']"
                name="internetBankingPaymentType"
                class="required"
                validation="required"
                @input="changeInternetBankingPaymentType"
              />
            </b-col>
            <b-col v-if="installmentPayForm.internetBankingPaymentType === 'BANKSLIP'">
              <b-tabs>
                <b-tab
                  active
                  :title="$t('DDA')"
                >
                  <b-card-actions
                    :title="$t('Selecione um boleto DDA para pagamento')"
                    :show-loading="ddaLoading"
                    action-refresh
                    style="border: solid 1px #eaeaea; border-radius: 5px"
                    @refresh="handleCheckingAccountSearchChange"
                  >
                    <b-row>
                      <b-col md="6">
                        <e-checking-account-combo
                          id="modal_pay_installment-input_checking_account_search"
                          ref="checkingAccountComboSearch"
                          v-model="checkingAccountSearchId"
                          :label="$t('Conta Corrente para consulta de boletos DDA')"
                          :type="['External']"
                          :store-id="storeId"
                          required
                          active-options
                          @single-option="
                            (checkAccId) => (installmentPayForm.checkingAccountId = checkAccId)
                          "
                          @input="handleCheckingAccountSearchChange"
                        />
                      </b-col>
                    </b-row>
                    <b-row>
                      <!-- <b-col md="3">
                        <FormulateInput
                          v-model="ddaFilter.document"
                          type="text"
                          :label="$t('CNPJ emissor')"
                          :placeholder="$t('CNPJ')"
                        />
                      </b-col> -->
                      <b-col md="3">
                        <FormulateInput
                          v-model="ddaFilter.initialDate"
                          type="datepicker"
                          :hour-default="12"
                          :label="$t('Data início')"
                          :placeholder="$t('dd/mm/aaaa')"
                          :only-calendar="true"
                          @input="handleCheckingAccountSearchChange"
                        />
                      </b-col>
                      <b-col md="3">
                        <FormulateInput
                          v-model="ddaFilter.finalDate"
                          type="datepicker"
                          :hour-default="12"
                          :label="$t('Data fim')"
                          :placeholder="$t('dd/mm/aaaa')"
                          :only-calendar="true"
                          @input="handleCheckingAccountSearchChange"
                        />
                      </b-col>
                      <b-col md="3">
                        <FormulateInput
                          v-model="ddaFilter.initialValue"
                          type="text-number"
                          currency="R$"
                          :precision="2"
                          :label="$t('Valor inicial')"
                          @blur="handleCheckingAccountSearchChange"
                        />
                      </b-col>
                      <b-col md="3">
                        <FormulateInput
                          v-model="ddaFilter.finalValue"
                          type="text-number"
                          currency="R$"
                          :precision="2"
                          :label="$t('Valor final')"
                          @blur="handleCheckingAccountSearchChange"
                        />
                      </b-col>
                    </b-row>

                    <div
                      v-if="ddaFilter.returnAll"
                      style="color: red; text-align: center"
                      class="mb-1"
                    >
                      {{
                        $t(
                          'Não foram encontrados boletos DDA com os filtros selecionados, portanto foram retornados todos os boletos DDA emitidos para a conta selecionada.'
                        )
                      }}
                    </div>

                    <b-table
                      ref="ddalist-table"
                      show-empty
                      striped
                      responsive
                      :class="{
                        bordered: true,
                        'mb-1': true,
                        'bill-pay-select-row': true,
                      }"
                      :tbody-tr-class="rowClass"
                      :fields="ddaFields"
                      :items="ddaList"
                      :empty-text="getEmptyTableMessage($tc('DDA_BANK_SLIP.NAME'), 'male')"
                      @row-clicked="onRowClickToSelectPay"
                    >
                      <template #cell(bulkPay)="row">
                        <FormulateInput
                          v-model="installmentPayForm.bankSlipDdaCode"
                          type="radio"
                          :element-class="['d-flex', 'mt-0']"
                          name="dda-select"
                          :value="row.item.code"
                        />
                      </template>
                    </b-table>
                  </b-card-actions>
                </b-tab>
                <b-tab :title="$t('Código de barras')">
                  <b-card-actions
                    :title="$t('Digite o código de barras do Boleto')"
                    :show-loading="ddaLoading"
                    style="border: solid 1px #eaeaea; border-radius: 5px"
                  >
                    <FormulateInput
                      v-model="installmentPayForm.bankSlipBarcode"
                      type="text"
                    />
                  </b-card-actions>
                </b-tab>
              </b-tabs>
              <!-- <b-card-actions
                :title="$t('Digite o código de barras do Boleto')"
                :show-loading="ddaLoading"
                style="border: solid 1px #eaeaea; border-radius: 5px"
              >
                <FormulateInput
                  v-model="installmentPayForm.bankSlipBarcode"
                  type="text"
                />
              </b-card-actions>
              <b-card-actions
                :title="$t('Ou selecione um boleto DDA para pagamento')"
                :show-loading="ddaLoading"
                action-refresh
                style="border: solid 1px #eaeaea; border-radius: 5px"
                @refresh="handleCheckingAccountSearchChange"
              >

              </b-card-actions> -->
            </b-col>
            <b-col v-else-if="installmentPayForm.internetBankingPaymentType === 'TAXES'">
              <template v-if="taxesPaymentDetails">
                <FormulateInput
                  v-model="installmentPayForm.internetBankingTaxType"
                  type="radio"
                  :options="internetBankingTaxesPaymentTypes()"
                  :label="$t('Tipo de Imposto/Taxa')"
                  :element-class="['d-flex', 'mt-1']"
                  class="required"
                  validation="required"
                />
                <b-row>
                  <b-col
                    v-if="taxField('city')"
                    md="3"
                  >
                    <FormulateInput
                      v-model="taxesPaymentDetails.city"
                      type="text"
                      :label="$t('Cidade')"
                      maxlength="150"
                      :placeholder="$t('SÃO PAULO')"
                      :validation="taxField('city').required ? 'required' : ''"
                      :class="taxField('city').required ? 'required' : ''"
                    />
                  </b-col>
                  <b-col
                    v-if="taxField('stateAbbreviation')"
                    md="2"
                  >
                    <e-address-province-combo
                      v-model="taxesPaymentDetails.stateAbbreviation"
                      :required="taxField('stateAbbreviation').required"
                    />
                  </b-col>
                  <b-col
                    v-if="taxField('taxPayer')"
                    md="3"
                  >
                    <FormulateInput
                      v-model="taxesPaymentDetails.taxPayer"
                      type="text"
                      maxlength="150"
                      :label="$t('Contribuinte')"
                      :placeholder="$t('JOÃO DA SILVA')"
                      :validation="taxField('taxPayer').required ? 'required' : ''"
                      :class="taxField('taxPayer').required ? 'required' : ''"
                    />
                  </b-col>
                  <b-col
                    v-if="taxField('revenueCode')"
                    md="3"
                  >
                    <FormulateInput
                      v-model="taxesPaymentDetails.revenueCode"
                      type="number"
                      maxlength="15"
                      :label="$t('Código da Receita')"
                      :placeholder="$t('1234')"
                      :validation="taxField('revenueCode').required ? 'required' : ''"
                      :class="taxField('revenueCode').required ? 'required' : ''"
                    />
                  </b-col>
                  <b-col
                    v-if="taxField('referenceNumber')"
                    md="3"
                  >
                    <FormulateInput
                      v-model="taxesPaymentDetails.referenceNumber"
                      type="number"
                      maxlength="15"
                      :label="$t('Número de Referência')"
                      :placeholder="$t('273981240192888')"
                      :validation="taxField('referenceNumber').required ? 'required' : ''"
                      :class="taxField('referenceNumber').required ? 'required' : ''"
                    />
                  </b-col>
                  <b-col
                    v-if="taxField('companyName')"
                    md="3"
                  >
                    <FormulateInput
                      v-model="taxesPaymentDetails.companyName"
                      type="number"
                      maxlength="15"
                      :label="$t('Nome da Empresa / Telefone')"
                      :placeholder="$t('Tecnologia e Cia - (11)5578-3821')"
                      :validation="taxField('companyName').required ? 'required' : ''"
                      :class="taxField('companyName').required ? 'required' : ''"
                    />
                  </b-col>
                  <b-col
                    v-if="taxField('paymentCode')"
                    md="3"
                  >
                    <FormulateInput
                      v-model="taxesPaymentDetails.paymentCode"
                      type="number"
                      maxlength="15"
                      :label="$t('Código de Pagamento')"
                      :placeholder="$t('5534')"
                      :validation="taxField('paymentCode').required ? 'required' : ''"
                      :class="taxField('paymentCode').required ? 'required' : ''"
                    />
                  </b-col>
                  <b-col
                    v-if="taxField('competency')"
                    md="3"
                  >
                    <FormulateInput
                      v-model="taxesPaymentDetails.competency"
                      v-mask="['####-##']"
                      :label="$t('Competência')"
                      :placeholder="$t('2025-01')"
                      :validation="taxField('competency').required ? 'required' : ''"
                      :class="taxField('competency').required ? 'required' : ''"
                    />
                  </b-col>
                  <b-col
                    v-if="taxField('gPSId')"
                    md="3"
                  >
                    <FormulateInput
                      v-model="taxesPaymentDetails.gPSId"
                      type="number"
                      maxlength="20"
                      :label="$t('Identificador')"
                      :placeholder="$t('544133928899000')"
                      :validation="taxField('gPSId').required ? 'required' : ''"
                      :class="taxField('gPSId').required ? 'required' : ''"
                    />
                  </b-col>
                  <b-col
                    v-if="taxField('assessmentDate')"
                    md="3"
                  >
                    <FormulateInput
                      ref="inputPaymentDate"
                      v-model="taxesPaymentDetails.assessmentDate"
                      type="datepicker"
                      :hour-default="12"
                      :label="$t('Data de Apuração')"
                      :placeholder="$t('dd/mm/aaaa')"
                      :validation="taxField('assessmentDate').required ? 'required' : ''"
                      :class="taxField('assessmentDate').required ? 'required' : ''"
                    />
                  </b-col>
                  <b-col
                    v-if="taxField('stateRegistration')"
                    md="3"
                  >
                    <FormulateInput
                      v-model="taxesPaymentDetails.stateRegistration"
                      type="number"
                      maxlength="15"
                      :label="$t('Inscrição Estadual')"
                      :placeholder="$t('183659182736')"
                      :validation="taxField('stateRegistration').required ? 'required' : ''"
                      :class="taxField('stateRegistration').required ? 'required' : ''"
                    />
                  </b-col>
                  <b-col
                    v-if="taxField('returnNumber')"
                    md="4"
                  >
                    <FormulateInput
                      v-model="taxesPaymentDetails.returnNumber"
                      type="number"
                      maxlength="15"
                      :label="$t('N° da Declaração')"
                      :placeholder="$t('183659182736')"
                      :validation="taxField('returnNumber').required ? 'required' : ''"
                      :class="taxField('returnNumber').required ? 'required' : ''"
                    />
                  </b-col>
                  <b-col
                    v-if="taxField('document')"
                    md="4"
                  >
                    <FormulateInput
                      v-model="taxesPaymentDetails.document"
                      :mask="['###.###.###-##', 'XX.XXX.XXX/XXXX-##']"
                      name="document"
                      type="text-mask"
                      :label="$t('CPF ou CNPJ')"
                      :placeholder="$t('73928427380')"
                      :validation="taxField('document').required ? 'required' : ''"
                      :class="taxField('document').required ? 'required' : ''"
                    />
                  </b-col>
                  <b-col
                    v-if="taxField('tagNumber')"
                    md="4"
                  >
                    <FormulateInput
                      v-model="taxesPaymentDetails.tagNumber"
                      type="number"
                      maxlength="15"
                      :label="$t('Inscrição na Divida Ativa ou Número da etiqueta')"
                      :placeholder="$t('8374618273764')"
                      :validation="taxField('tagNumber').required ? 'required' : ''"
                      :class="taxField('tagNumber').required ? 'required' : ''"
                    />
                  </b-col>
                  <b-col
                    v-if="taxField('reference')"
                    md="4"
                  >
                    <FormulateInput
                      v-model="taxesPaymentDetails.reference"
                      v-mask="['##-####']"
                      :label="$t('Referência (mm-aaaa)')"
                      :placeholder="$t('01-2025')"
                      :validation="taxField('reference').required ? 'required' : ''"
                      :class="taxField('reference').required ? 'required' : ''"
                    />
                  </b-col>
                  <b-col
                    v-if="taxField('installment')"
                    md="4"
                  >
                    <FormulateInput
                      v-model="taxesPaymentDetails.installment"
                      type="number"
                      maxlength="15"
                      :label="$t('N° do AIIM ou Nº DEICMEME ou Nº Parcelamento')"
                      :placeholder="$t('848293745')"
                      :validation="taxField('installment').required ? 'required' : ''"
                      :class="taxField('installment').required ? 'required' : ''"
                    />
                  </b-col>
                  <b-col
                    v-if="taxField('iNSSValue')"
                    md="3"
                  >
                    <FormulateInput
                      v-model="taxesPaymentDetails.iNSSValue"
                      type="text-number"
                      currency="R$"
                      :precision="2"
                      :label="$t('Valor do INSS')"
                      :validation="taxField('iNSSValue').required ? 'required' : ''"
                      :class="taxField('iNSSValue').required ? 'required' : ''"
                    />
                  </b-col>
                  <b-col
                    v-if="taxField('otherValue')"
                    md="3"
                  >
                    <FormulateInput
                      v-model="taxesPaymentDetails.otherValue"
                      type="text-number"
                      currency="R$"
                      :precision="2"
                      :label="$t('Valor Outras Entidades')"
                      :validation="taxField('otherValue').required ? 'required' : ''"
                      :class="taxField('otherValue').required ? 'required' : ''"
                    />
                  </b-col>
                  <b-col
                    v-if="taxField('revenueValue')"
                    md="3"
                  >
                    <FormulateInput
                      v-model="taxesPaymentDetails.revenueValue"
                      type="text-number"
                      currency="R$"
                      :precision="2"
                      :label="$t('Valor da Receita (Nominal ou Corrigida)')"
                      :validation="taxField('revenueValue').required ? 'required' : ''"
                      :class="taxField('revenueValue').required ? 'required' : ''"
                    />
                  </b-col>
                  <b-col
                    v-if="taxField('defaultInterest')"
                    md="3"
                  >
                    <FormulateInput
                      v-model="taxesPaymentDetails.defaultInterest"
                      type="text-number"
                      currency="R$"
                      :precision="2"
                      :label="$t('Juros de Mora')"
                      :validation="taxField('defaultInterest').required ? 'required' : ''"
                      :class="taxField('defaultInterest').required ? 'required' : ''"
                    />
                  </b-col>
                  <b-col
                    v-if="taxField('lateFee')"
                    md="3"
                  >
                    <FormulateInput
                      v-model="taxesPaymentDetails.lateFee"
                      type="text-number"
                      currency="R$"
                      :precision="2"
                      :label="$t('Multa de Mora ou Multa por Infração')"
                      :validation="taxField('lateFee').required ? 'required' : ''"
                      :class="taxField('lateFee').required ? 'required' : ''"
                    />
                  </b-col>
                  <b-col
                    v-if="taxField('financeCharge')"
                    md="3"
                  >
                    <FormulateInput
                      v-model="taxesPaymentDetails.financeCharge"
                      type="text-number"
                      currency="R$"
                      :precision="2"
                      :label="$t('Acréscimo Financeiro')"
                      :validation="taxField('financeCharge').required ? 'required' : ''"
                      :class="taxField('financeCharge').required ? 'required' : ''"
                    />
                  </b-col>
                  <b-col
                    v-if="taxField('legalFees')"
                    md="3"
                  >
                    <FormulateInput
                      v-model="taxesPaymentDetails.legalFees"
                      type="text-number"
                      currency="R$"
                      :precision="2"
                      :label="$t('Honorários Advocatícios')"
                      :validation="taxField('legalFees').required ? 'required' : ''"
                      :class="taxField('legalFees').required ? 'required' : ''"
                    />
                  </b-col>
                  <b-col
                    v-if="taxField('address')"
                    md="3"
                  >
                    <FormulateInput
                      v-model="taxesPaymentDetails.address"
                      type="text"
                      maxlength="150"
                      :label="$t('Endereço')"
                      :placeholder="$t('Av Interlagos 3501')"
                      :validation="taxField('address').required ? 'required' : ''"
                      :class="taxField('address').required ? 'required' : ''"
                    />
                  </b-col>
                  <b-col
                    v-if="taxField('phone')"
                    md="3"
                  >
                    <FormulateInput
                      v-model="taxesPaymentDetails.phone"
                      v-mask="['(##)####-####', '(##)#####-####']"
                      type="text"
                      :label="$t('Telefone')"
                      :placeholder="$t('(99)99999-9999')"
                      :validation="taxField('phone').required ? 'required' : ''"
                      :class="taxField('phone').required ? 'required' : ''"
                    />
                  </b-col>
                  <b-col
                    v-if="taxField('cNAE')"
                    md="2"
                  >
                    <FormulateInput
                      v-model="taxesPaymentDetails.cNAE"
                      type="text"
                      :label="$t('CNAE')"
                      :placeholder="$t('82736457')"
                      maxlength="8"
                      :validation="taxField('cNAE').required ? 'required' : ''"
                      :class="taxField('cNAE').required ? 'required' : ''"
                    />
                  </b-col>
                  <b-col
                    v-if="taxField('postalCode')"
                    md="2"
                  >
                    <FormulateInput
                      v-model="taxesPaymentDetails.postalCode"
                      type="text"
                      :label="$t('CEP')"
                      :placeholder="$t('73841282')"
                      maxlength="8"
                      :validation="taxField('postalCode').required ? 'required' : ''"
                      :class="taxField('postalCode').required ? 'required' : ''"
                    />
                  </b-col>
                  <b-col
                    v-if="taxField('observation')"
                    md="3"
                  >
                    <FormulateInput
                      v-model="taxesPaymentDetails.observation"
                      type="text"
                      maxlength="200"
                      :label="$t('Observação')"
                      :placeholder="$t('Observação')"
                      :validation="taxField('observation').required ? 'required' : ''"
                      :class="taxField('observation').required ? 'required' : ''"
                    />
                  </b-col>
                </b-row>
              </template>
            </b-col>
          </b-row>

          <b-row
            v-if="
              !isBulkPay &&
                !isPaymentConfirmation &&
                selectedCheckingAccount &&
                selectedCheckingAccount.workspaceId &&
                installmentPayForm.payOnInternetBanking &&
                (installmentPayForm.paymentMethod.method === paymentTypeEnum.PIX ||
                  installmentPayForm.paymentMethod.method === paymentTypeEnum.STORE_CREDIT)
            "
          >
            <b-col md="12">
              <FormulateInput
                v-model="installmentPayForm.internetBankingPixType"
                type="radio"
                :options="internetBankingPixPaymentTypes()"
                :label="$t('Tipo de chave PIX')"
                :element-class="['d-flex', 'mt-1']"
                class="required"
                validation="required"
              />
            </b-col>
            <b-col>
              <FormulateInput
                v-if="installmentPayForm.internetBankingPixType !== 'AGENCIA_CONTA'"
                v-model="installmentPayForm.pixCode"
                type="text"
                :label="$t('Chave PIX')"
              />
              <b-row v-else>
                <b-col md="4">
                  <FormulateInput
                    v-model="installmentPayForm.pixBankAccountBankCode"
                    type="text"
                    :label="$t('Código do banco')"
                    class="required"
                    validation="required"
                  />
                </b-col>
                <b-col md="4">
                  <FormulateInput
                    v-model="installmentPayForm.pixBankAccountBranch"
                    type="text"
                    :label="$t('Agência')"
                    class="required"
                    validation="required"
                  />
                </b-col>
                <b-col md="4">
                  <FormulateInput
                    v-model="installmentPayForm.pixBankAccountAccountNumber"
                    type="text"
                    :label="$t('Conta')"
                    class="required"
                    validation="required"
                  />
                </b-col>
                <b-col md="4">
                  <FormulateInput
                    v-model="installmentPayForm.pixBankAccountAccountType"
                    type="select"
                    :label="$t('Tipo de conta')"
                    class="required"
                    validation="required"
                    :options="[
                      { value: 'CONTA_CORRENTE', label: $t('Conta Corrente') },
                      { value: 'CONTA_POUPANCA', label: $t('Conta Poupança') },
                      { value: 'CONTA_PAGAMENTO', label: $t('Conta Pagamento') },
                    ]"
                  />
                </b-col>
                <b-col md="4">
                  <FormulateInput
                    v-model="installmentPayForm.pixBankAccountDocumentType"
                    type="select"
                    :label="$t('Tipo de documento')"
                    class="required"
                    validation="required"
                    :options="[
                      { value: 'CPF', label: $t('CPF') },
                      { value: 'CNPJ', label: $t('CNPJ') },
                    ]"
                  />
                </b-col>
                <b-col md="4">
                  <FormulateInput
                    v-model="installmentPayForm.pixBankAccountDocumentNumber"
                    type="text"
                    :label="$t('Número do documento')"
                    class="required"
                    validation="required"
                  />
                </b-col>
              </b-row>
            </b-col>
            <b-col md="12">
              <FormulateInput
                v-model="installmentPayForm.canPayToThirdParty"
                type="switch"
                :label="$t('Permite pagamento a terceiro?')"
                :instruction="
                  $t(
                    'Quando selecionado, o sistema permitirá que o pagamento seja feito para uma pessoa diferente do que está cadastrado na despesa.'
                  )
                "
              />
            </b-col>
          </b-row>

          <b-row v-if="isBulkPay && !isPaymentConfirmation">
            <b-col>
              <FormulateInput
                id="modal_pay_installment-group_items"
                v-model="groupItems"
                type="switch"
                :label="$t('Agrupar baixas?')"
                :instructions="[
                  {
                    text: $t(
                      'Serão criados lançamentos na conta corrente agrupados por Forma de Pagamento e Bandeira do Cartão (quando aplicável), com o valor da soma das parcelas agrupadas'
                    ),
                  },
                  {
                    text: $t(
                      'O estorno de uma parcela baixada em grupo implicará no estorno de todas as parcelas que foram baixadas juntas'
                    ),
                  },
                ]"
              />
            </b-col>
          </b-row>
          <b-row v-if="isBulkPay || isPaymentConfirmation">
            <b-col>
              <FormulateInput
                v-if="selectedCheckingAccount"
                :value="selectedCheckingAccount.name"
                type="label"
                :label="$t('Conta Corrente')"
              />
              <b-table
                show-empty
                responsive
                class="bordered"
                :fields="fields"
                :items="installmentBulkPay"
              >
                <template #cell(discount)="row">
                  <FormulateInput
                    :id="`modal_bulk_pay_installment-discount-${row.index}`"
                    v-model="row.item.discount"
                    type="text-number"
                    currency="R$"
                    :precision="2"
                    @blur="(value) => onInputDiscount(value, row.item)"
                  />
                </template>
                <template #cell(interest)="row">
                  <FormulateInput
                    :id="`modal_bulk_pay_installment-interest-${row.index}`"
                    v-model="row.item.interest"
                    type="text-number"
                    currency="R$"
                    :precision="2"
                    @blur="(value) => onInputInterest(value, row.item)"
                  />
                </template>
                <template #cell(paymentValue)="row">
                  <FormulateInput
                    :id="`modal_bulk_pay_installment-payment_value-${row.index}`"
                    :value="row.item.value + (row.item.interest || 0) - (row.item.discount || 0)"
                    type="label"
                    filter="currency"
                    :precision="2"
                  />
                </template>

                <template #cell(action)="row">
                  <e-grid-actions
                    :show-update="false"
                    :show-delete="true"
                    @update="() => {}"
                    @delete="onRemoveInstallment(row.item)"
                  />
                </template>

                <template #custom-foot>
                  <tr>
                    <th
                      :colspan="isPaymentConfirmation ? 7 : 5"
                      class="text-right"
                    >
                      Total
                    </th>
                    <th class="text-right">
                      {{ getTotalInfos.totalInstallmentsValue | currency }}
                    </th>
                    <th
                      v-if="!isPaymentConfirmation"
                      class="text-right"
                    >
                      {{ getTotalInfos.totalDiscountValue | currency }}
                    </th>
                    <th class="text-right">
                      {{ getTotalInfos.totalInterestValue | currency }}
                    </th>
                    <th class="text-right">
                      {{ getTotalInfos.totalPaymentValue | currency }}
                    </th>
                  </tr>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row v-else />
        </FormulateForm>
      </b-card-actions>
    </template>
    <template #sidebar-footer>
      <e-button
        id="modal_pay_installment-btn_cancel"
        class="mr-1"
        variant="outline-primary"
        :text="$t('Cancelar')"
        :text-shortcuts="['ESC']"
        @click="hideModal"
      />

      <e-button
        id="modal_pay_installment-btn_confirm"
        variant="primary"
        icon="cash"
        :text="$t('Confirmar baixa')"
        :busy="saving"
        @click="onConfirm"
      />
    </template>
  </e-sidebar>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'
import { BRow, BCol, BTable, BTabs, BTab } from 'bootstrap-vue'
import { alerts, paymentTypes, stringUtils } from '@/mixins'
import BCardActions from '@/@core/components/b-card-actions/BCardActions.vue'
import {
  EAddressProvinceCombo,
  ECheckingAccountCombo,
  EGridActions,
  EButton,
  ESidebar,
} from '@/views/components'
import Decimal from 'decimal.js-light'

const getInitialInstallmentPayForm = () => ({
  id: null,
  checkingAccountId: null,
  paymentDate: new Date(),
  paymentValue: 0,
  value: 0,
  interest: 0,
  discount: 0,
  payOnInternetBanking: false,
  canPayToThirdParty: false,
  bankSlipBarcode: null,
  bankSlipDdaCode: null,
  pixCode: null,
  internetBankingPixType: 'QRCODE',
  internetBankingPaymentType: 'BANKSLIP',
  internetBankingTaxType: null,
  accountsPayableRowVersion: null,
  pixBankAccountBankCode: null,
  pixBankAccountBranch: null,
  pixBankAccountAccountNumber: null,
  pixBankAccountAccountType: null,
  pixBankAccountDocumentNumber: null,
  pixBankAccountDocumentType: null,
})

const getInitialTaxesPaymentDetails = () => ({
  // taxType: null,
  dueDate: null,
  revenueCode: null,
  document: null,
  value: null,
  tagNumber: null,
  reference: null,
  installment: null,
  revenueValue: null,
  defaultInterest: null,
  lateFee: null,
  financeCharge: null,
  legalFees: null,
  taxPayer: null,
  competency: null,
  gPSId: null,
  iNSSValue: null,
})

const getInitialDdaFilter = () => ({
  document: null,
  initialDate: null,
  finalDate: null,
  initialValue: null,
  finalValue: null,
  returnAll: false,
})

export default {
  components: {
    ESidebar,
    BRow,
    BCol,
    BTable,
    EButton,
    BCardActions,
    EGridActions,
    ECheckingAccountCombo,
    EAddressProvinceCombo,
    BTabs,
    BTab,
  },

  mixins: [alerts, paymentTypes, stringUtils],

  props: {
    isPaymentConfirmation: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      showSidebar: false,
      loading: false,
      saving: false,
      isBulkPay: false,
      groupItems: false,
      installmentPayForm: getInitialInstallmentPayForm(),
      installmentBulkPay: [],
      taxesPaymentDetails: getInitialTaxesPaymentDetails(),
      ddaFilter: getInitialDdaFilter(),
      storeId: null,
      ddaList: [],
      ddaLoading: false,
      rowVersion: null,
      accountsPayableRowVersion: null,
      checkingAccountSearchId: null,
      taxesFields: {
        GAREICMS: {
          taxType: { required: false },
          city: { required: false },
          stateAbbreviation: { required: false },
          paymentDate: { required: false },
          tags: { required: false },
          dueDate: { required: false },
          revenueCode: { required: true },
          stateRegistration: { required: false },
          document: { required: true },
          tagNumber: { required: false },
          reference: { required: false },
          installment: { required: false },
          revenueValue: { required: true },
          defaultInterest: { required: false },
          lateFee: { required: false },
          financeCharge: { required: false },
          legalFees: { required: false },
          taxPayer: { required: false },
          address: { required: false },
          phone: { required: false },
          cNAE: { required: false },
          observation: { required: false },
        },
        GAREITCMD: {
          taxType: { required: false },
          city: { required: false },
          stateAbbreviation: { required: false },
          paymentDate: { required: false },
          tags: { required: false },
          taxPayer: { required: false },
          dueDate: { required: false },
          revenueCode: { required: true },
          returnNumber: { required: false },
          document: { required: true },
          tagNumber: { required: false },
          defaultInterest: { required: false },
          lateFee: { required: false },
          financeCharge: { required: false },
          legalFees: { required: false },
          address: { required: false },
          phone: { required: false },
          postalCode: { required: false },
          observation: { required: false },
        },
        DARF: {
          taxType: { required: false },
          city: { required: false },
          stateAbbreviation: { required: false },
          paymentDate: { required: false },
          tags: { required: false },
          companyName: { required: false },
          assessmentDate: { required: false },
          document: { required: true },
          revenueCode: { required: true },
          referenceNumber: { required: false },
          dueDate: { required: true },
          value: { required: true },
          lateFee: { required: false },
          defaultInterest: { required: false },
        },
        GPS: {
          taxType: { required: false },
          city: { required: false },
          stateAbbreviation: { required: false },
          paymentDate: { required: false },
          tags: { required: false },
          companyName: { required: false },
          paymentCode: { required: true },
          competency: { required: true },
          gPSId: { required: true },
          iNSSValue: { required: true },
          otherValue: { required: false },
          lateFee: { required: false },
        },
      },
    }
  },

  computed: {
    ...mapState('app', ['checkingAccounts']),
    ...mapGetters('app', ['allStoreOptions']),
    fields() {
      return [
        {
          label: this.$t('Ações'),
          key: 'action',
          thClass: 'text-center',
          tdClass: 'text-center',
          thStyle: { width: '100px' },
        },
        {
          label: this.$t('Id Parc.'),
          key: 'id',
          thClass: 'text-center',
          tdClass: 'text-center',
          thStyle: { width: '70px' },
        },
        {
          label: this.$t('Descrição'),
          key: 'accountsPayable.description',
          thClass: 'text-center',
          tdClass: 'text-left',
        },
        {
          label: this.$t('Tipo (Internet Banking)'),
          key: 'internetBankingPaymentType',
          thClass: 'text-center',
          tdClass: 'text-left',
          thStyle: { width: '120px' },
          hide: !this.isPaymentConfirmation,
        },
        {
          label: this.$t('Parcela'),
          key: 'installment',
          thClass: 'text-center',
          tdClass: 'text-center',
          thStyle: { width: '60px' },
        },
        {
          label: this.$t('Vencimento'),
          key: 'dueDate',
          thClass: 'text-center',
          tdClass: 'text-center',
          thStyle: { width: '120px' },
          formatter: val => this.$options.filters.date(val),
        },
        {
          label: this.$t('Dt. Pagamento'),
          key: 'paymentDate',
          thClass: 'text-center',
          tdClass: 'text-center',
          thStyle: { width: '120px' },
          formatter: val => this.$options.filters.date(val),
          hide: !this.isPaymentConfirmation,
        },
        {
          label: this.$t('Valor da parcela'),
          key: 'value',
          thClass: 'text-center',
          tdClass: 'text-right',
          thStyle: { width: '120px', minWidth: '120px' },
          formatter: val => this.$options.filters.currency(val),
        },
        {
          label: this.$t('Desconto'),
          key: 'discount',
          thClass: 'text-center',
          tdClass: 'text-center',
          thStyle: { width: '130px', minWidth: '130px' },
          hide: this.isPaymentConfirmation,
        },
        {
          label: this.$t('Juros'),
          key: 'interest',
          thClass: 'text-center',
          tdClass: 'text-center',
          thStyle: { width: '130px', minWidth: '130px' },
        },
        {
          label: this.$t('Valor a pagar'),
          key: 'paymentValue',
          thClass: 'text-center',
          tdClass: 'text-center',
          thStyle: { width: '130px', minWidth: '130px' },
        },
      ].filter(item => !item.hide)
    },
    hasOtherPaymentMethodsThanPix() {
      return !!this.installmentBulkPay.find(inst => inst.paymentMethod?.method !== 'Pix')
    },

    ddaFields() {
      return [
        {
          label: '',
          key: 'bulkPay',
          tdClass: 'pl-2 justify-content-center align-items-center',
          thStyle: { width: '50px' },
        },
        {
          label: this.$t('Código de barras'),
          key: 'code',
          sortKey: 'code',
          tdClass: 'text-center',
          sortable: true,
        },
        {
          label: this.$t('CNPJ do Pagador'),
          key: 'payerDocumentNumber',
          sortKey: 'payerDocumentNumber',
          tdClass: 'text-center',
          sortable: true,
          formatter: val => this.formatPayerWithStore(val),
        },
        {
          label: this.$t('Venc.'),
          key: 'dueDate',
          tdClass: 'text-center',
          thStyle: { width: '100px' },
          formatter: val => this.$options.filters.date(val),
          sortable: true,
        },
        {
          label: this.$t('Fornecedor'),
          key: 'beneficiary',
          formatter: val =>
            `${this.$options.filters.cpfCnpj(val.beneficiaryDocument)} - ${val.beneficiaryName}`,
        },
        {
          label: this.$t('Valor'),
          key: 'nominalValue',
          tdClass: 'text-right',
          thStyle: { minWidth: '110px', width: '110px' },
          formatter: val => this.$options.filters.currency(new Decimal(val.replace(',', '.'))),
          sortable: true,
        },
      ]
    },

    getTotalInfos() {
      const result = this.installmentBulkPay.reduce(
        (totals, inst) => ({
          totalInstallmentsValue: (inst.value || 0) + totals.totalInstallmentsValue,
          totalInterestValue: (inst.interest || 0) + totals.totalInterestValue,
          totalDiscountValue: (inst.discount || 0) + totals.totalDiscountValue,
        }),
        {
          totalInstallmentsValue: 0,
          totalInterestValue: 0,
          totalDiscountValue: 0,
        }
      )
      result.totalPaymentValue = new Decimal(result.totalInstallmentsValue)
        .minus(result.totalDiscountValue)
        .plus(result.totalInterestValue)
        .toNumber()
      return result
    },
    selectedCheckingAccount() {
      const bulkFirst = this.installmentBulkPay.length ? this.installmentBulkPay[0] : null
      const cc = this.checkingAccounts.find(
        acc =>
          // eslint-disable-next-line eqeqeq
          acc.id == this.installmentPayForm?.checkingAccountId || bulkFirst?.checkingAccountId
      )
      return cc
    },
    selectedSearchCheckingAccount() {
      return this.checkingAccounts.find(
        // eslint-disable-next-line eqeqeq
        acc => acc.id == this.checkingAccountSearchId
      )
    },
    taxField() {
      return fieldName => {
        if (!this.installmentPayForm.internetBankingTaxType) {
          return null
        }

        const fieldSet = this.taxesFields[this.installmentPayForm.internetBankingTaxType]
        return fieldSet[fieldName]
      }
    },
    hasManyStores() {
      return (
        new Set(this.installmentBulkPay.map(inst => inst.accountsPayable?.store?.id)).size > 1
      )
    },
    title() {
      if (this.isPaymentConfirmation) {
        return this.$t('Confirmação de pagamento')
      }
      if (this.isBulkPay) {
        return this.$t('Baixa em massa')
      }
      return `${this.$t('Baixa de parcela')} - ${
        this.installmentPayForm?.accountsPayable?.description
      }`
    },
  },

  methods: {
    getStoreByDocument(documentNumber) {
      const numericDocument = this.getOnlyNumbers(documentNumber)
      if (!numericDocument || !Array.isArray(this.allStoreOptions)) {
        return null
      }

      return this.allStoreOptions.find(store => {
        const documents = [store?.cnpj]
        return documents.some(document => this.getOnlyNumbers(document) === numericDocument)
      })
    },
    formatPayerWithStore(documentNumber) {
      const formattedDocument = this.$options.filters.cpfCnpj(documentNumber)
      const store = this.getStoreByDocument(documentNumber)
      if (!store) {
        return `${formattedDocument}`
      }

      return `${formattedDocument} - ${store.tradingName}`
    },
    changeInternetBankingPaymentType() {
      if (this.installmentPayForm.internetBankingPaymentType === 'BANKSLIP') {
        this.installmentPayForm.internetBankingTaxType = null
        this.taxesPaymentDetails = getInitialTaxesPaymentDetails()
      } else if (this.installmentPayForm.internetBankingPaymentType === 'TAXES') {
        this.installmentPayForm.bankSlipDdaCode = null
        this.installmentPayForm.bankSlipBarcode = null
        this.installmentPayForm.internetBankingTaxType = 'GAREICMS'
      }
    },
    rowClass(item) {
      return item?.code === this.installmentPayForm?.bankSlipDdaCode
        ? 'selected-row payment-pending'
        : 'payment-pending'
    },
    async handleCheckingAccountChange() {
      if (this.checkingAccountSearchId === null) {
        this.checkingAccountSearchId = this.installmentPayForm.checkingAccountId
        this.handleCheckingAccountSearchChange()
      }
    },
    async getDdaList({
      checkingAccountId,
      accountsPayableInstallmentId,
      document,
      initialDate,
      finalDate,
      initialValue,
      finalValue,
      filterType,
    }) {
      return (
        await this.$http.get('/api/financial/internet-banking/payments/bank-slip/dda', {
          params: {
            checkingAccountId,
            accountsPayableInstallmentId,
            document,
            initialDate,
            finalDate,
            initialValue,
            finalValue,
            filterType,
          },
        })
      ).data
    },
    async handleCheckingAccountSearchChange() {
      this.ddaList = []
      if (
        !this.isBulkPay &&
        this.selectedSearchCheckingAccount?.workspaceId &&
        this.installmentPayForm.paymentMethod?.method === this.paymentTypeEnum.BANK_SLIP
      ) {
        try {
          this.ddaLoading = true
          this.ddaList = await this.getDdaList({
            checkingAccountId: this.selectedSearchCheckingAccount?.id,
            accountsPayableInstallmentId: this.installmentPayForm.id,
            document: this.ddaFilter.document,
            initialDate: this.ddaFilter.initialDate,
            finalDate: this.ddaFilter.finalDate,
            initialValue: this.ddaFilter.initialValue,
            finalValue: this.ddaFilter.finalValue,
          })
          if (!this.ddaList.length) {
            this.ddaList = await this.getDdaList({
              checkingAccountId: this.selectedSearchCheckingAccount?.id,
              accountsPayableInstallmentId: this.installmentPayForm.id,
              filterType: 'IgnoreDocument',
            })
          } else {
            this.ddaFilter.returnAll = false
          }

          if (!this.ddaList.length) {
            this.ddaList = await this.getDdaList({
              checkingAccountId: this.selectedSearchCheckingAccount?.id,
              accountsPayableInstallmentId: this.installmentPayForm.id,
              filterType: 'None',
            })
            this.ddaFilter.returnAll = true
          } else {
            this.ddaFilter.returnAll = false
          }
        } catch (error) {
          this.showError({ error })
        } finally {
          this.ddaLoading = false
        }
      }
    },
    async onConfirm() {
      if (!this.validForm()) {
        this.showInvalidDataMessage()
        return
      }

      if (
        !this.isPaymentConfirmation &&
        !this.isBulkPay &&
        this.selectedCheckingAccount.workspaceId &&
        this.installmentPayForm.payOnInternetBanking &&
        !this.installmentPayForm.bankSlipDdaCode &&
        !this.installmentPayForm.bankSlipBarcode &&
        !this.installmentPayForm.pixCode &&
        this.installmentPayForm.internetBankingPixType !== 'AGENCIA_CONTA' &&
        this.installmentPayForm.internetBankingPaymentType !== 'TAXES'
      ) {
        this.showError({
          message: this.$t(
            this.installmentPayForm.paymentMethod.method === this.paymentTypeEnum.BANK_SLIP
              ? 'Selecione um boleto DDA ou digite o código de barras.'
              : 'Digite o código de barras do PIX ou pix copia/cola.'
          ),
        })
        return
      }

      this.saving = true
      try {
        if (this.isBulkPay) {
          const payload = this.installmentBulkPay.map(inst =>
            this.prepareToSavePay(this.installmentPayForm, inst)
          )
          await this.$http.patch('/api/accounting/accounts-payable-installments/bulk-pay', {
            accountsPayableInstallments: payload,
            groupItems: this.groupItems,
            payOnInternetBanking: this.installmentPayForm.payOnInternetBanking,
          })
          this.showSuccess({ message: this.$t('Pagamento em massa concluído.') })
        } else {
          const payload = this.prepareToSavePay(this.installmentPayForm)
          console.log(payload)
          await this.$http.patch('/api/accounting/accounts-payable-installments/pay', payload)
          this.showSuccess({ message: this.$t('Pagamento concluído.') })
        }

        const itemList = this.isBulkPay ? this.installmentBulkPay : [this.installmentPayForm]
        this.setNeedToRefreshData(true)
        this.$emit('after-confirm', { itemList })
        this.hideModal()
      } catch (error) {
        this.showError({ error })
      } finally {
        this.saving = false
      }
    },

    prepareToSavePay(paymentForm, data = getInitialInstallmentPayForm()) {
      if (this.isPaymentConfirmation) {
        return data
      }

      const paymentDate = paymentForm.paymentDate
        ? moment(paymentForm.paymentDate).format('YYYY-MM-DD')
        : null

      return {
        ...data,
        id: data.id || paymentForm.id,
        checkingAccountId: paymentForm.checkingAccountId,
        paymentDate: paymentForm.paymentDate,
        paymentValue: data.paymentValue || paymentForm.paymentValue,
        interest: data.interest || paymentForm.interest,
        discount: data.discount || paymentForm.discount,
        value: data.value || paymentForm.value,
        rowVersion: data.rowVersion || paymentForm.rowVersion,
        accountsPayableRowVersion: data.accountsPayableRowVersion || this.accountsPayableRowVersion,
        payOnInternetBanking: paymentForm.payOnInternetBanking,
        canPayToThirdParty: paymentForm.canPayToThirdParty,
        internetBankingPaymentCode:
          paymentForm.bankSlipBarcode ?? paymentForm.bankSlipDdaCode ?? paymentForm.pixCode,
        internetBankingPaymentType: (() => {
          if (this.isBulkPay) {
            return null
          }

          if (paymentForm.paymentMethod.method === this.paymentTypeEnum.BANK_SLIP) {
            if (paymentForm.internetBankingPaymentType === 'BANKSLIP') {
              return paymentForm.bankSlipDdaCode ? 'Dda' : 'Barcode'
            }
            if (paymentForm.internetBankingPaymentType === 'TAXES') {
              return 'Taxes'
            }
          }

          return 'Pix'
        })(),
        internetBankingPixType: paymentForm.internetBankingPixType,
        pixBankAccountDetails: paymentForm.internetBankingPixType === 'AGENCIA_CONTA'
          ? {
              bankCode: paymentForm.pixBankAccountBankCode,
              branch: paymentForm.pixBankAccountBranch,
              accountNumber: paymentForm.pixBankAccountAccountNumber,
              accountType: paymentForm.pixBankAccountAccountType,
              documentNumber: paymentForm.pixBankAccountDocumentNumber,
              documentType: paymentForm.pixBankAccountDocumentType,
            }
          : null,
        taxesPaymentDetails: this.setEmptyStringsToNull(
          paymentForm.internetBankingTaxType
            ? {
                ...this.taxesPaymentDetails,
                taxType: paymentForm.internetBankingTaxType,
                revenueValue: paymentForm.value,
                document: this.getOnlyNumbers(this.taxesPaymentDetails.document),
                paymentDate,
                assessmentDate: paymentDate,
                dueDate: paymentForm.dueDate,
                value: paymentForm.value,
              }
            : null
        ),
      }
    },

    async showModal(isBulk, installmentsList) {
      this.loading = true
      // this.$bvModal.show('pay_installment_modal')
      this.showSidebar = true
      this.isBulkPay = isBulk

      try {
        const { data } = await this.$http.get(
          '/api/accounting/accounts-payable-installments/list-to-pay',
          { params: { accountsPayableInstallmentIds: installmentsList } }
        )

        if (!data?.length) {
          throw new Error(this.$t('Parcela a pagar não encontrada.'))
        }

        const installment = data[0]

        this.accountsPayableRowVersion = installment.accountsPayable.rowVersion
        this.storeId = installment.accountsPayable.store.id

        const defaultData = getInitialInstallmentPayForm()
        if (isBulk) {
          this.installmentBulkPay = data.map(inst => ({
            ...defaultData,
            ...inst,
            paymentValue: inst.value,
            paymentDate: this.isPaymentConfirmation ? inst.paymentDate : defaultData.paymentDate,
            rowVersion: inst.rowVersion,
            accountsPayableRowVersion: inst.accountsPayableRowVersion,
          }))
        } else {
          this.installmentPayForm = {
            ...defaultData,
            ...installment,
            paymentValue: installment.value,
            paymentDate: defaultData.paymentDate,
            rowVersion: installment.rowVersion,
          }
          this.ddaFilter = {
            ...getInitialDdaFilter(),
            initialDate: moment(installment.dueDate).add(-5, 'day').toDate(),
            finalDate: moment(installment.dueDate).add(5, 'day').toDate(),
            initialValue: installment.value - 10,
            finalValue: installment.value + 10,
          }
        }
      } catch (error) {
        this.showError({ error })
        this.hideModal()
      } finally {
        this.loading = false
      }
    },
    cleanModalData() {
      this.installmentPayForm = getInitialInstallmentPayForm()
      this.taxesPaymentDetails = getInitialTaxesPaymentDetails()
      this.ddaFilter = getInitialDdaFilter()
      this.checkingAccountSearchId = null
      this.installmentBulkPay = []
      this.storeId = null
      this.showSidebar = false
    },
    hideModal() {
      this.cleanModalData()
    },

    onInputDiscount(discount, item) {
      // eslint-disable-next-line no-param-reassign
      item.paymentValue = this.calculatePaymentValue(item.value, item.interest, discount)
    },
    onInputInterest(interest, item) {
      // eslint-disable-next-line no-param-reassign
      item.paymentValue = this.calculatePaymentValue(item.value, interest, item.discount)
    },

    calculatePaymentValue(originalValue, interest, discount) {
      const result = new Decimal(originalValue || 0)
        .sub(discount || 0)
        .add(interest || 0)
        .toNumber()
      if (!result) return 0
      return result
    },

    onRemoveInstallment(item) {
      const indexFound = this.installmentBulkPay.findIndex(
        installment => installment.id === item.id
      )
      this.installmentBulkPay.splice(indexFound, 1)
      this.setNeedToRefreshData(true)
      this.$emit('remove-installment', item)
    },

    validForm() {
      if (this.isPaymentConfirmation) {
        return true
      }

      this.$refs.modalPayForm.showErrors()

      return this.$refs.modalPayForm.isValid
    },
    async onRowClickToSelectPay(item) {
      if (this.installmentPayForm.bankSlipDdaCode === item.code) {
        this.installmentPayForm.bankSlipDdaCode = null
      } else {
        this.installmentPayForm.bankSlipDdaCode = item.code
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
